module.exports = __webpack_public_path__ + "img/5stars-forex.cd8a0e7b.png";